<div class="home-container">
  <div class="container-fluid container-white">

    <app-carousel-new></app-carousel-new>

    <div class="container-fluid home-section-events">
      <div class="row">
        <div class="col text-center">
          <h2 class="home-title">Tutorial Ricerca Avanzata</h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/videoseries?list=PLJA2hJi5-mqSPOzH2vY-WnqhEWTyDpNGM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </div>
    </div>

    <div class="container-fluid home-section-cedlab">
      <div class="row">
        <div class="col text-center">
          <h2 class="home-title">Chi siamo</h2>
        </div>
      </div>
      <div class="row">
        <div class="col text-center home-cedlab-text" [innerHTML]="aboutCedlabService.findSection('CHI SIAMO').descrizione">
        </div>
      </div>
    </div>
    <div class="container-fluid home-section-events">
      <div class="row">
        <div class="col text-center">
          <h2 class="home-title">Calendario eventi</h2>
        </div>
      </div>
      <app-calendar-view-week *ngIf="calendarReady" [inputEvents]="events"
        (openEventDetails)="openEventDetails($event)"></app-calendar-view-week>

      <div *ngIf="calendarReady === false" class="alert alert-danger" role="alert">
        {{calendarLoadingFailed}}
      </div>

    </div>
    <div class="container-fluid home-section-video">
      <div class="row">
        <div class="col text-center">
          <h2 class="home-title">CedLAB Academy</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-lg-3" *ngFor="let item of videoList">
          <div class="thumbnail-effect">
            <a (click)="loadVideo(item)">
              <img [src]="item.thumbnailImg">
              <div class="middle">
                <i class="fa fa-youtube-play fa-3x" aria-hidden="true"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <a class="home-more" target="_blank" href="https://www.youtube.com/channel/UCTji4ptUBbuLHKJENx5EMCw">
            Vedi tutti &gt;
          </a>
        </div>
      </div>
    </div>
    <div class="container-fluid home-section-areas">
      <div class="row">
        <div class="col text-center">
          <h2 class="home-title">Macro-aree</h2>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <h3>AIRBAG-CEDOLA-MEMORIA-COUPON-AUTOCALLABLE-PHONIX</h3>
          <h3>MINUS-MINUSVALENZE-MAXI-COUPON-PHOENIX</h3>
          <h3>CEDOLA-CASH COLLECT-FIXED-CEDOLA FISSA</h3>
          <h3>REVERSE-SHORT</h3>
          <h3>RECOVERY-BONUS</h3>
        </div>
      </div>
    </div>
  </div>
  <div id="video-overlay" *ngIf="activeVideo" (click)="closePlayer()">
    <iframe *ngIf="activeVideo" width="850" height="530" [src]="getVideoUrl(activeVideo)" frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
    </iframe>
  </div>
</div>

